/** Analytics identifiers for WELDING PROJECTS THAT SELL™. Empty = off. */
export const META_PIXEL_ID = '1821144602257054'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
